import { motion } from "framer-motion";
import {
    Home,
    TrendingUp,
    HeartHandshake,
    CalendarCheck,
    PiggyBank,
} from "lucide-react";

const IMG =
    "https://images.unsplash.com/photo-1714647211976-5fab46d0f079?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHxfHxoYXBweSUyMGNvdXBsZSUyMG1vdmluZyUyMGluJTIwbmV3JTIwaG9tZSUyMGtleXMlMjBzbWlsaW5nfGVufDB8fHx8MTc5MDYwNDYwOHww&ixlib=rb-4.1.0&q=85";

const BENEFITS = [
    {
        icon: Home,
        title: "Estabilidad",
        desc: "Olvídate del alquiler y construye tu hogar.",
    },
    {
        icon: TrendingUp,
        title: "Inversión segura",
        desc: "Genera patrimonio con una compra inteligente.",
    },
    {
        icon: HeartHandshake,
        title: "Pertenencia",
        desc: "Enraíza, conéctate con tu comunidad.",
    },
    {
        icon: CalendarCheck,
        title: "Planificación",
        desc: "Diseña tu futuro con certeza.",
    },
    {
        icon: PiggyBank,
        title: "Ahorro",
        desc: "Reduce gastos a largo plazo.",
    },
];

export default function Benefits() {
    return (
        <section
            id="ventajas"
            data-testid="benefits-section"
            className="bg-white py-20 lg:py-28 px-4 sm:px-6 lg:px-8"
        >
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="relative order-2 lg:order-1"
                >
                    <div className="rounded-[2rem] overflow-hidden aspect-[4/5] max-h-[620px] w-full shadow-2xl shadow-slate-300/50">
                        <img
                            src={IMG}
                            alt="Pareja feliz con las llaves de su nuevo hogar"
                            className="w-full h-full object-cover"
                            loading="lazy"
                        />
                    </div>
                    <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-[#1F3B5B] text-white rounded-3xl px-7 py-6 shadow-xl">
                        <p className="font-display text-3xl font-extrabold">
                            100%
                        </p>
                        <p className="text-sm text-slate-300 mt-1">
                            financiación posible
                        </p>
                    </div>
                </motion.div>

                <div className="order-1 lg:order-2">
                    <motion.div
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-600">
                            Beneficios
                        </p>
                        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A]">
                            ¿Por qué comprar tu vivienda?
                        </h2>
                    </motion.div>

                    <div className="mt-10 space-y-4">
                        {BENEFITS.map((b, i) => (
                            <motion.div
                                key={b.title}
                                data-testid={`benefit-${i}`}
                                initial={{ opacity: 0, x: 40 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{
                                    duration: 0.55,
                                    delay: i * 0.08,
                                    ease: [0.16, 1, 0.3, 1],
                                }}
                                className="flex items-start gap-5 rounded-2xl border border-slate-100 bg-[#F5F7FA]/60 hover:bg-white hover:border-emerald-200 p-5 transition-[background-color,border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/60"
                            >
                                <span className="shrink-0 flex items-center justify-center w-12 h-12 rounded-xl bg-emerald-500/10 text-emerald-600">
                                    <b.icon size={22} />
                                </span>
                                <span>
                                    <h3 className="font-display font-semibold text-lg text-[#0F172A]">
                                        {b.title}
                                    </h3>
                                    <p className="text-slate-600 text-[15px] mt-1">
                                        {b.desc}
                                    </p>
                                </span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
